const user = {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    /**
     * @description 重置
     * @param {*} { commit, dispatch }
     */
    async resetAll () {
      /**
       * 重置相关数据
       */
    },
  }
}
export default user




